import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { Table, Button, Input, Modal, ModalBody, ModalHeader, ModalFooter, Col, Row, FormGroup, Label } from 'reactstrap';
import { Organisation } from "../../interfaces/models/Organisation"
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useOrganisation } from '../../hooks/useOrganisation';
import Loading from "../../components/Loading";
import { addOrganisation ,updateOrganisation } from "../../graphql/content-management/addOrganisations";
import { useMutation } from "@apollo/client";
import toast from "react-hot-toast";

interface ModalProperties { 
    action : string;
    buttonName : string;
}

const OrganisationListPage = () => {

    const breadcrumbsData = [
        { name: 'Content List', path: `${DASHBOARD_ROOT}/content-management/` },
        { name: 'Organisation List', path: `${DASHBOARD_ROOT}/content-management/organisation-list` },
    ];

    const history = useHistory();

    const { data : organisationData, loading : organisationLoading} = useOrganisation();

    const [organisations, setOrganisations] = useState<Organisation[]>([]);
    const [organisationsFiltered, setOrganisationsFiltered] = useState<Organisation[]>([]);
    const [selectOrg, setSelectOrg] = useState<Organisation>(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOnProcess, setIsOnProcess] = useState(false);
    const [orgName, setOrgName] = useState("");
    const [modalProperty, setModalProperty] = useState<ModalProperties>({ action : "", buttonName : "" });

    const [addOrganisationHook] = useMutation(addOrganisation,{
        onCompleted : () =>{
            toast.success("Organisation was successfully added");
        },
        onError : () =>{
            toast.error("Something went wrong whilst adding the Organisation . Please try again or if issue persists, please contact us");
        }
    });

    const [updateOrganisationHook] = useMutation(updateOrganisation,{
        onCompleted : () =>{
            toast.success("Organisation was successfully updated");
        },
        onError : () =>{
            toast.error("Something went wrong whilst Updating the Organisation . Please try again or if issue persists, please contact us");
        }
    });

    const OpenOrganisation = (item : Organisation) => {
        history.push(`${DASHBOARD_ROOT}/content-management/organisation-list/${item._id}?name=${item.name}`);
    }

    const TriggerSearch = (e : React.KeyboardEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value?.toLowerCase().trim();
        setOrganisationsFiltered(organisations.filter(u => u.name.toLowerCase().includes(value)))
    }

    useEffect(() => {
        if(organisationData) {
            setOrganisations(organisationData.organisations);
            setOrganisationsFiltered(organisationData.organisations);
        }
    },[organisationData]);

    //#region Adding and Updating of Organisation   

    const ToggleModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const HandleOpenAdd = () => {
        setOrgName("");
        ToggleModal();
        setModalProperty({
            buttonName : "Add",
            action : "add"
        });
    }

    const HandleEditAdd = (item : Organisation) => {
        setOrgName(item.name);
        setSelectOrg(item);
        setModalProperty({
            buttonName : "Edit",
            action : "edit"
        });
        ToggleModal();
    }

    const TriggerSubmit = async () => {
        if(!orgName){
            return;
        }
        if(modalProperty.action === "add") {
            setIsOnProcess(true);
            const isAdded = await addOrganisationHook({
                variables : {
                    record : { name : orgName.trim() }
                }
            }).then((res) => res.errors ? false : true ).catch(()=>false);
            setIsOnProcess(false);

            if(!isAdded) {
                return;
            }
        }
        else if(modalProperty.action === "edit") {
            setIsOnProcess(true);
            const isAdded = await updateOrganisationHook({
                variables : {
                    _id : selectOrg._id,
                    record : { name : orgName.trim() }
                }
            }).then((res) => res.errors ? false : true ).catch(()=>false);
            setIsOnProcess(false);

            if(!isAdded) {
                return;
            }
        }

        setTimeout(() => {
            window.location.reload();
        },700);
    }


    //#endregion Adding and Updating of Organisation

    return  (
        <>
            <Breadcrumbs 
                crumbs={breadcrumbsData}
            />
            <Row>
               <Col md={6}>
                    <div className="d-flex pb-3 pt-3">
                        <label className="pr-3 pt-1">Search: </label>
                        <Input name="search" onKeyUp={(e) => { TriggerSearch(e); }} placeholder="Type Organisation name here to search"/>
                    </div>
               </Col> 
               <Col md={6} className="text-right">
                    <Button color="primary" className="mt-2" onClick={HandleOpenAdd}>Add</Button>
               </Col> 
            </Row>
            
            

            <div className="table-responsive bg-white table-max-height"  >
                <Table bordered>
                    <thead>
                        <tr>
                            <th>Organisation Name</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (organisationsFiltered.length ===0 && !organisationLoading) && 
                            <tr>
                                <td colSpan={2} className="text-center">No Data Found</td>
                            </tr>
                        }
                        {
                            organisationLoading &&
                            <tr>
                                <td colSpan={2}>
                                    <Loading />
                                </td>
                            </tr>
                        }
                        {
                            organisationsFiltered.map((item, index) => 
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>
                                        <Button color="primary" size='sm' onClick={()=>{ HandleEditAdd(item) }} >Edit</Button>
                                        <Button color="primary" size='sm' onClick={()=>{ OpenOrganisation(item) }} >View</Button>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>

            <Modal
                id="organisation-manage-modal"
                backdrop={true}
                isOpen={isModalOpen}>
                <ModalHeader toggle={ToggleModal} className="mb-0">
                    <p className="text-lg">{modalProperty.buttonName} Organisation</p>
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Organisation Name</Label>
                        <Input type="text" value={orgName} onChange={(e) => setOrgName(e.currentTarget.value)} placeholder="Name of organisation"/>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" disabled={isOnProcess} onClick={ToggleModal} >Close </Button>
                    <Button color="primary" disabled={isOnProcess} onClick={TriggerSubmit} >{modalProperty.buttonName}</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export { OrganisationListPage as OrganisationList };